import React from 'react';

import { BaseIconProps } from './';

export const Check2 = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1686747,0,0,-2.1686747,2.1686744,1088.6747)"
    d="M 200,59 -1,272 90,363 206,247 407,447 497,356 Z"
    fill={fill}
  />
);
